// extracted by mini-css-extract-plugin
export default {"loading_div":"signup_loading_div__04jgN","span":"signup_span__xEadV"};